export default __webpack_public_path__ + "static/painting4-3e17d015c66f293463477e72ed302108.jpg";